
import moment from 'moment';

import Util from 'service/util';
import Loading from 'component/Loading';

function getTurnAroundTime(x)
{
  if (!x.complete_dtm) return '';
  let mins = moment(x.complete_dtm).diff(x.sent_dtm, 'minutes');
  return (Math.round(mins * 100) / 100).toFixed(2) + ' m';
}

export const EInvoicingAuditBatchTable = ({
  items, onSelect
}) =>
{
  // skip if not ready
  if (!items) {
    return <Loading />
  }

  // skip if no data
  if (!items.length) {
    return <p className="message yellow">沒有記錄</p>;
  }

  // render
  return (
    <table className="einvoicing-audit-table data-table">
      <colgroup>
        <col id="col-eiab-datetime"     width="150px" />
        <col id="col-eiab-time-spent"   width="80px" />
        <col id="col-eiab-sent-by"      width="200px" />
        <col id="col-eiab-invoice-type" width="80px" />
        <col id="col-eiab-pending"      width="80px" />
        <col id="col-eiab-accepted"     width="80px" />
        <col id="col-eiab-sent"         width="80px" />
        <col id="col-eiab-delivered"    width="80px" />
        <col id="col-eiab-read"         width="80px" />
        <col id="col-eiab-failed"       width="80px" />
        <col id="col-eiab-details"      width="auto" />
      </colgroup>
      <thead>
        <tr>
          <th className="col-eiab-datetime">時間</th>
          <th className="col-eiab-time-spent">TAT</th>
          <th className="col-eiab-sent-by">負責同事</th>
          <th className="col-eiab-invoice-type">單據類型</th>
          <th className="col-eiab-pending">待寄送</th>
          <th className="col-eiab-accepted">處理中</th>
          <th className="col-eiab-sent">已寄出</th>
          <th className="col-eiab-delivered">已寄達</th>
          <th className="col-eiab-read">已讀</th>
          <th className="col-eiab-failed">失敗</th>
          <th className="col-eiab-details"></th>
        </tr>
      </thead>
      <tbody>
        { items.map(x =>
          <tr key={`${x.batch_id}-${x.destination}`} batch={x.batch_id}>
            <td className="col-eiab-datetime">{ Util.LongDate(x.sent_dtm )}</td>
            <td className="col-eiab-time-spent">{ getTurnAroundTime(x) }</td>
            <td className="col-eiab-sent-by">{ x.sent_by }</td>
            <td className="col-eiab-invoice-type">{ Util.getInvoiceTypeName(x.invoice_type) }</td>
            <td className="col-eiab-pending">{ x.pending.length }</td>
            <td className="col-eiab-accepted">{ x.accepted.length }</td>
            <td className="col-eiab-sent">{ x.sent.length }</td>
            <td className="col-eiab-delivered">{ x.delivered.length }</td>
            <td className="col-eiab-read">{ x.read.length }</td>
            <td className="col-eiab-failed">{ x.failed.length }</td>
            <td className="col-eiab-details">
              <button className="btn btn-small blue" onClick={e=>onSelect?.(x)}>詳細</button>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default EInvoicingAuditBatchTable;

